// @flow
import EnvConfig from 'config';
import { LocusApiModel } from 'common/modules/api';

export const setPersonnelPassword = new LocusApiModel({
    baseUrl: EnvConfig.platformEndPoint,
    resourceName: 'personnel',
    idAttrs: 'personnelId',
    endPoint: `/client/{clientId}/personnel-master/{personnelId}/forgot-password-update`
});

export const productSettings = new LocusApiModel({
    endPoint: `/client/{clientId}/namespace/{product}/settings`
});

export const clientSettings = new LocusApiModel({
    baseUrl: EnvConfig.apiEndPoint,
    endPoint: `/client/{clientId}/settings`
});

export const teamSettings = new LocusApiModel({
    baseUrl: EnvConfig.apiEndPoint,
    endPoint: `/client/{clientId}/team/{teamId}/settings`
});

export const businessUnit = new LocusApiModel({
    baseUrl: EnvConfig.apiEndPoint,
    endPoint: `/client/{clientId}/businessUnit`
});

export const businessUnitSettings = new LocusApiModel({
    baseUrl: EnvConfig.apiEndPoint,
    endPoint: `/client/{clientId}/businessUnit/{businessUnitId}/settings`
});

export const plan = new LocusApiModel({
    baseUrl: EnvConfig.apiEndPoint,
    endPoint: `/client/{clientId}/batch/{batchId}/plan/{planId}` // TODO: Fix queryParams - include & originalPlan
});

export const quoteSelectionConfigSearch = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    endPoint: `/client/{clientId}/quote-selection-config-search`
});

export const quoteSelectionConfig = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    endPoint: `/client/{clientId}/quote-selection-config/{quoteSelectionConfigId}`
});

export const updateQuoteSelectionConfig = new LocusApiModel({
    baseUrl: EnvConfig.orchestratorEndPoint,
    endPoint: `/client/{clientId}/quote-selection-config`
});

export const client = new LocusApiModel({
    baseUrl: EnvConfig.apiEndPoint,
    endPoint: `/client/{clientId}`
});

export const renewExpiry = new LocusApiModel({
    baseUrl: EnvConfig.platformEndPoint,
    endPoint: `/client/{clientId}/renew-expiry`
});

export const status = new LocusApiModel({
    baseUrl: EnvConfig.platformEndPoint,
    endPoint: `/client/{clientId}/status`
});

export const stage = new LocusApiModel({
    baseUrl: EnvConfig.platformEndPoint,
    endPoint: `/client/{clientId}/stage`
});

export const updateDomains = new LocusApiModel({
    baseUrl: EnvConfig.platformEndPoint,
    endPoint: `/client/{clientId}/domain`
});
